import { Direction } from './direction';

export class Departement {

    id: number|undefined;
    active: boolean;
    code: string;
    label:string;
    direction:Direction;
  
  }